import './App.css';
import { Route, Routes } from "react-router-dom";

// Eagerly loaded – needed on every page / first paint
import React, { Suspense, lazy } from 'react';
import Home from './components/Home/Home';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import DynamicTitle from './components/DynamicTitle/DynamicTitle';

// Lazy loaded – only downloaded when the user navigates to that route
const OurJourney = lazy(() => import('./components/OurJourney/OurJourney'));
const CampusandFacilities = lazy(() => import('./components/CampusandFacilities/CampusandFacilities'));
const LeaderShip = lazy(() => import('./components/LeaderShip/LeaderShip'));
const Philosophy = lazy(() => import('./components/Philosophy/Philosophy'));
const PreSchool = lazy(() => import('./components/PreSchool/PreSchool'));
const Play = lazy(() => import('./components/Play/Play'));
const Icse = lazy(() => import('./components/Icse/Icse'));
const LearningCenter = lazy(() => import('./components/LearningCenter/LearningCenter'));
const Careers = lazy(() => import('./components/Careers/Careers'));
const Gallery = lazy(() => import('./components/Gallery/Gallery'));
const Calender = lazy(() => import('./components/Calendar/Calendar'));
const ISC = lazy(() => import('./components/ISC/ISC'));
const Admissions = lazy(() => import('./components/Admissions/Admissions'));
const Contact = lazy(() => import('./components/Contact/Contact'));
const ContactDemo = lazy(() => import('./components/ContactDemo/ContactDemo'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy/PrivacyPolicy'));
const Faq = lazy(() => import('./components/Faq/Faq'));
const Downloads = lazy(() => import('./components/Downloads/Downloads'));

function App() {
  return (
    <div className="App">
      <DynamicTitle />
      <Header />

      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route element={<Home />} path="/" />
          <Route element={<OurJourney />} path="/our-journey" />
          <Route element={<CampusandFacilities />} path="/campus-and-facilities" />
          <Route element={<LeaderShip />} path="/leadership" />
          <Route element={<Philosophy />} path="/philosophy" />
          <Route element={<PreSchool />} path="/pre-school" />
          <Route element={<Play />} path="/play" />
          <Route element={<Icse />} path="/icse" />
          <Route element={<LearningCenter />} path="/outdoor-learning-center" />
          <Route element={<Careers />} path="/careers" />
          <Route element={<Calender />} path="/calender" />
          <Route element={<Gallery />} path="/gallery" />
          <Route element={<ISC />} path="/isc" />
          <Route element={<Admissions />} path="/admissions" />
          <Route element={<Contact />} path="/contact" />
          <Route element={<ContactDemo />} path="/contact-demo" />
          <Route element={<PrivacyPolicy />} path="/privacy-policy" />
          <Route element={<Faq />} path="/Faq" />
          <Route element={<Downloads />} path="/downloads" />
        </Routes>
      </Suspense>

      <Footer />
    </div>
  );
}

export default App;
